import service from '@/utils/request';
export var addMerchantAccountInfo = function addMerchantAccountInfo(data) {
  return service({
    url: '/merchantOrder/addMerchantAccountInfo',
    method: 'post',
    data: data
  });
};
export var getMerchantAccountInfo = function getMerchantAccountInfo(data) {
  return service({
    url: '/merchantOrder/getMerchantAccountInfo',
    method: 'post',
    data: data
  });
};
export var editAccountInfo = function editAccountInfo(data) {
  return service({
    url: '/merchantOrder/editAccountInfo',
    method: 'post',
    data: data
  });
};
export var addMerchantWithdrawOrder = function addMerchantWithdrawOrder(data) {
  return service({
    url: '/merchantOrder/addMerchantWithdrawOrder',
    method: 'post',
    data: data
  });
};
export var getCurrencyList = function getCurrencyList() {
  return service({
    url: '/merchantOrder/getCurrencyList',
    method: 'get'
  });
};
export var getMerchantAccountSignList = function getMerchantAccountSignList() {
  return service({
    url: '/merchantOrder/getMerchantAccountSignList',
    method: 'post'
  });
};
export var getMerchantOrderList = function getMerchantOrderList(data) {
  return service({
    url: '/merchantOrder/getMerchantOrderList',
    method: 'post',
    data: data
  });
};
export var operationWithdrawOrder = function operationWithdrawOrder(data) {
  return service({
    url: '/merchantOrder/operationWithdrawOrder',
    method: 'post',
    data: data
  });
};
export var getOperationStatusList = function getOperationStatusList() {
  return service({
    url: '/merchantOrder/getOperationStatusList',
    method: 'get'
  });
};
export var getMerchantPayOutChannelList = function getMerchantPayOutChannelList() {
  return service({
    url: '/merchantOrder/getMerchantPayOutChannelList',
    method: 'post'
  });
};